$formKontakt = $(".js-form_kontakt");
$formKontaktButton = $(".js-form_kontakt_button");


$formKontakt.on("submit", function(e){
    e.preventDefault();
    $form = $(this);

    $.ajax({
        url: $form.data("ajax"),
        type: 'POST',
        data: $form.serialize()
    }).done(function() {
        $form.trigger("reset");
        $form.find(".js-success").slideDown();
        setTimeout(function(){
            $form.find(".js-success").slideUp();
        },3000)
    });
});